import { CourseTypeEnum } from "@/interFace/courses/types";

export const Routes = {
  SIGN_IN: "/en/auth/sign-in",
  _SIGN_IN: "/auth/sign-in",
  SIGN_UP: "/en/auth/sign-up",
  SIGN_UP_TESTER_REQUEST: "/en/auth/sign-up/tester-request",
  _SIGN_UP_TESTER_REQUEST: "/auth/sign-up/tester-request",
  SCHOOLS: "/en/schools",
  TERMS_CONDITIONS: "/en/terms-conditions",
  SIGN_UP_CONFIRMATION: "/en/auth/sign-up/confirmation",
  _SIGN_UP_CONFIRMATION: "/auth/sign-up/confirmation",
  LOGOUT: "/en/auth/logout",
  FORGOT_PWD: "/en/auth/forgot-password",
  FORGOT_PWD_CONFIRMATION: "/en/auth/forgot-password/confirmation",
  RESET_PWD: "/en/auth/reset-password",
  RESET_PWD_CONFIRMATION: "/en/auth/reset-password/confirmation",
  _VERIFY_EMAIL: "/auth/verify-email",
  _VERIFY_EMAIL_CONFIRMATION: "/en/auth/verify-email/confirmation",
  PROFILE: "/en/profile",
  RESULTS: "/en/profile/results",
  HOMEPAGE: "/en/",
  LEARNING_TOOLS: "/en/learning-tools",
  LEARNING_TOOLS_QUIZZES: "/en/learning-tools/quizzes",
  Education_Provider_Discovery: "/en/?mode=natural",
  HOW_TO: "/en/how-it-works",
  Education_Providers_FAQ: "/en/claimant/education-providers-faq",
  THE_TEAM: "/en/the-team",
  SETTINGS: "/en/settings",
  PLAY: "/en/play",
  QUIZ_FEATURES: "/en/features/quiz",
  CLASSROOM_FEATURES: "/en/features/classroom",
  CLASSROOM_FEATURES_TESTING: "/en/features/classroom/plans",
  CHESS_FEATURES: "/en/features/chess",
  CLASSROOM_TESTER_REQUEST: "/en/features/classroom/tester-request",
  PLAYING: "/en/play/[PLACEHOLDER]",
  PLAYING_CONFIG: "/en/play/[PLACEHOLDER]/configure",
  PLAY_RESULTS: "/en/play/[PLACEHOLDER]/results",
  CART: "/en/cart",
  CART_SUCCESS: "/en/cart/success",
  CHECKOUT: "/en/checkout/",
  CHECKOUT_SUCCESS: "/en/checkout/success",
  SCHOOL_WORKSPACE: "/en/school",
  CLAIMANT_ROOT: "/en/claimant",
  PARENTS_ROOT: "/en/parents",
  PARENTS_CHILDREN: "/en/parents/children",
  PARENTS_ANALYTICS: "/en/parents/analytics",
  DASHBOARD_COURSES: "/en/dashboard",
  DASHBOARD_ANALYTICS: "/en/dashboard/analytics",
  DASHBOARD_DETAILS: "/en/dashboard/[PLACEHOLDER]",
  DASHBOARD_CLASSROOM_DETAILS: "/en/dashboard/classroom/[PLACEHOLDER]",
  DASHBOARD_CLASSROOM_CREDIT_HISTORY: "/en/dashboard/classroom/[PLACEHOLDER]/credit-history",
  DASHBOARD_CLASSROOM_QUIZ_ACTIVITY: "/en/dashboard/classroom/[PLACEHOLDER]/quizzes",
  DASHBOARD_QUIZ_DETAILS: "/en/dashboard/quiz/[PLACEHOLDER]",
  DASHBOARD_LEARN: "/en/learn",
  DASHBOARD_REVIEWS: "/en/review",
  DASHBOARD_QUIZ: "/en/quiz",
  DASHBOARD_QUIZ_RESULTS: "/en/quiz/[PLACEHOLDER]/results",
  QUIZZES: "/en/quizzes",
  QUIZ_DETAILS: "/en/quizzes/[PLACEHOLDER]",
  QUIZ_TRIAL_CHECKOUT: "/en/quizzes/[PLACEHOLDER]/trial",
  INBOX: "/en/inbox",
  FRIENDS: "/en/inbox/friends",
  CONTACTS: "/en/inbox/contacts",
  RACE: "/en/racer",
  RACE_JOIN: "/en/racer/join",
  RACE_REGISTRATION: "/en/racer-registration/[PLACEHOLDER]",
  RACING: "/en/racer/[PLACEHOLDER]",
  RACE_RESULTS: "/en/racer/[PLACEHOLDER]/results",
  CONTACT: "/en/contact",
  CONTACT_CONFIRMATION: "/en/contact/confirmation",
  TRANSFER: "/en/transfer/[PLACEHOLDER]",
  TRANSFER_CONFIRMATION: "/en/transfer/[PLACEHOLDER]/confirmation",

  Tutors_Classrooms: "/en/tutors/classrooms",
  Tutors_Centres: "/en/tutors/centres",
  Tutors_Centres_Admin_Access: "/en/tutors/centres/admin-workspace-access",
  Tutors_Centres_Members: "/en/tutors/centres/members",
  Tutors_Centres_Edits: "/en/tutors/centres/edits",
  Tutors_Asset_Library: "/en/tutors/library",
  TUTORS_ROOT: "/en/tutors",
  Tutors_Classroom_Create: "/en/tutors/classrooms/create",
  Tutors_Classroom_Details: "/en/tutors/classrooms/[PLACEHOLDER]",
  Tutors_Classroom_Credit_History: "/en/tutors/classrooms/[PLACEHOLDER]/credit-history",
  Tutors_Classroom_Edit: "/en/tutors/edit/[PLACEHOLDER]",
  Tutors_Classroom_Lessons_Order: "/en/tutors/classrooms/[PLACEHOLDER]/lessons/order",
  Tutors_Classroom_Create_Lesson: "/en/tutors/classrooms/[PLACEHOLDER]/lesson/create",
  Tutors_Classroom_Lesson_Details: "/en/tutors/classrooms/[PLACEHOLDER]/lesson/[PLACEHOLDER2]",
  Tutors_Classroom_Create_Content: "/en/tutors/classrooms/[PLACEHOLDER]/lesson/[PLACEHOLDER2]/content/create",
  Tutors_Classroom_Contents_Order: "/en/tutors/classrooms/[PLACEHOLDER]/lesson/[PLACEHOLDER2]/contents/order",
  Tutors_Classroom_Students: "/en/tutors/classrooms/[PLACEHOLDER]/students",
  Tutors_Classroom_Quizzes: "/en/tutors/classrooms/[PLACEHOLDER]/quizzes",
  Tutors_Classroom_Quiz_Analytics: "/en/tutors/classrooms/[PLACEHOLDER]/quizzes/[PLACEHOLDER2]",

  Tutors_Quizzes: "/en/tutors/quiz",
  Tutors_Quiz_Create: "/en/tutors/quiz/create",
  Tutors_Quiz_Details: "/en/tutors/quiz/[PLACEHOLDER]",
  Tutors_Quiz_Delete: "/en/tutors/quiz/[PLACEHOLDER]/delete",
  Tutors_Quiz_Questions_Delete: "/en/tutors/quiz/[PLACEHOLDER]/questions/delete/[PLACEHOLDER2]/",
  Tutors_Quiz_Questions_Create: "/en/tutors/quiz/[PLACEHOLDER]/questions/create/[PLACEHOLDER2]",
  Tutors_Quiz_Questions_Order:"/en/tutors/quiz/[PLACEHOLDER]/questions/order/[PLACEHOLDER2]",
  Tutors_Quiz_Questions_Test: "/en/tutors/quiz/[PLACEHOLDER]/questions/test/",
  Tutors_Quiz_Leaderboard: "/en/tutors/quiz/[PLACEHOLDER]/leaderboard",
  Tutors_Quiz_Results: "/en/tutors/quiz/[PLACEHOLDER]/results",

  // Not in use
  Tutors_Classroom_Join: "/en/tutors/classroom/join/[PLACEHOLDER]",
  Tutors_Classroom_Join_Confirmation: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation",
  Tutors_Classroom_Join_Confirmation_Error: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation/error",
  Tutors_Classroom_Join_Confirmation_Success: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation/success",
  Tutors_Classroom_Join_Confirmation_Already: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation/already",
  Tutors_Classroom_Join_Confirmation_Closed: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation/closed",
  Tutors_Classroom_Join_Confirmation_NotFound: "/en/tutors/classroom/join/[PLACEHOLDER]/confirmation/not-found",

  Bookings: "/en/bookings/",
  BookingDetails: "/en/bookings/[PLACEHOLDER]",
  Education_Public_List: "/en/education",
  Education_Public_Search_List: "/en/search-education",
  Education_Public_Detail: "/en/education/[PLACEHOLDER]",
  Education_Public_Claim: "/en/education/[PLACEHOLDER]/claim",
};

export const getLink = (culture: string, link: string, id: string = '', secondId: string = '') => {
  if(link == null || link == undefined || link == "") {
    return "#";
  }
  
  if(culture == null || culture == undefined || culture == "") {
    culture = "en";
  }

  var query_id = id?? "";
  let url = link.replace(`/en/`, `/${culture}/`);

  if(id != null && id != undefined && id != "") {
    url = url.replace("[PLACEHOLDER]", query_id);
  }

  if (secondId != null && secondId != undefined && secondId != "") {
    url = url.replace("[PLACEHOLDER2]", secondId);
  }

  if (url.includes("[PLACEHOLDER]")) {
    url = url.replace("[PLACEHOLDER]", "");
  }

    if (url.includes("[PLACEHOLDER2]")) {
      url = url.replace("[PLACEHOLDER2]", "");
    }

  return url;
};

export const getDashboardDetailsRoute = (courseTypeId?: number) => {
  switch (courseTypeId) {
    case CourseTypeEnum.Classroom:
      return Routes.DASHBOARD_CLASSROOM_DETAILS;
    case CourseTypeEnum.Quiz:
      return Routes.DASHBOARD_QUIZ_DETAILS;
    case CourseTypeEnum.TableSquare:
    case CourseTypeEnum.Geography:
    case CourseTypeEnum.General:
    case CourseTypeEnum.Alphabet:
    case CourseTypeEnum.NatoPhoneticAlphabet:
    default:
      return Routes.DASHBOARD_DETAILS;
  }
};

export const getDashboardDetailsLink = (
  culture: string,
  id: string,
  courseTypeId?: number
) => {
  return getLink(culture, getDashboardDetailsRoute(courseTypeId), id);
};

export const Constants = { 
  TokenName: 'firebaseToken',
  Uid: 'uid',
};
